import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import numeral from "numeral";

import { colors } from "../../theme";

const Container = styled.div`
  font-size: 1.4rem;

  p {
    margin-bottom: 1.4rem;
  }

  strong {
    color: ${colors.green};
  }

  i {
    color: ${colors.primaryColor};
    margin-right: 6px;
  }
`;

const Address = styled.p`
  font-weight: 700;
`;

function SupportCheckPayment({ amount, email }) {
  return (
    <Container>
      <p>
        Règlement par chèque d'un montant de{" "}
        <strong>{numeral(amount).format("0.00")}€</strong> à l'ordre de
        "Le Média", à envoyer à cette adresse&nbsp;:
      </p>
      <Address>
        Le Média
        <br />
        242 boulevard Voltaire <br />
        75011 Paris, France
      </Address>
      <p>
        <i className="fas fa-exclamation-circle" />
        N'oubliez pas de préciser votre adresse email "<strong>{email}</strong>"
        dans votre courrier !
      </p>
    </Container>
  );
}

SupportCheckPayment.propTypes = {
  amount: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
};

export default SupportCheckPayment;
